import axios from "axios";
import { config } from "../../../enviroment";
import moment from "moment";
import { apolloClientService } from "../../../services/apollo-client";

export function meterAlertsCall(
  startDate,
  endDate,
  origin,
  accountId,
  customerClass,
  announcementEndDate
) {
  let APIinput = "";
  const ANNOUNCEMENT_VALUE="ANNOUNCEMENT"
  if (origin === ANNOUNCEMENT_VALUE) {
    APIinput =
      `query{getAnnouncementList(input:{IsPublic:"LOGGED_IN",announcementType:"ANNOUNCEMENTS",StartDate:"` +
      startDate +
      `",EndDate:"` +
      announcementEndDate +
      `",CustomerClass:"` +
      customerClass +
      `"}){AnnouncementId,AnnouncementTitle,AnnouncementDescription,IsPublic,ExpirationDateTime,CreateDateTime,StartDate,AnnouncementType,AnnouncementStatus,CustomerClass,IsPublic,IsRead}}`;
  } else {
    APIinput =
      `{getAlerts(input:{origin:"` +
      origin +
      `",
      startDate:"` +
      startDate +
      `",
      endDate:"` +
      endDate +
      `",
      accountId: "` +
      accountId +
      `"  
      })}`;
  }

  return new Promise((resolve, reject) => {
    axios
      .post(config.urls.COMMUNICATION_SERVICE_BASE_URL, { query: APIinput })
      .then((response) => {
        resolve(response.data);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}

export default function getContentData(languageCode, categoryCode) {
  // apollo client request here
  if (localStorage.getItem("bearer")) {
    const GET_CONTENT = `{getContents(input:{languageCode:"${languageCode}",categoryCode:"${categoryCode}"}) }`;
    return apolloClientService.ApolloClientgqls(GET_CONTENT);
  }
}

export function getDropdownpData(groupCode,languageCode) {
  let APIquery =
    `{  getDropdownData(input:{groupCode:"` +
    groupCode +
    `",languageCode:"${languageCode}"})
   }`;
  return apolloClientService.ApolloClientgqls(APIquery);
}


export function updateData(origin, id, accountId) {
  let APIinput = "";
  if (origin === "ANNOUNCEMENT") {
    APIinput =
      `query{updateAnnouncementStatus(input:{announcementId:` + id + `})} `;
  } else {
    APIinput =
      `query{updateAlertStatus(input:{alertId:` +
      id +
      `,accountId:"` +
      accountId +
      `"})}`;
  }
  // return apolloClientService.ApolloClientgqlsCommunication(APIinput);

  return new Promise((resolve, reject) => {
    axios
      .post(config.urls.COMMUNICATION_SERVICE_BASE_URL, { query: APIinput })
      .then((response) => {
        resolve(response.data);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}
